// extracted by mini-css-extract-plugin
export default {"root":"SingleSignOnErrorPage_root__oYBRC","text":"SingleSignOnErrorPage_text__ddXCE","header":"SingleSignOnErrorPage_header__9PHSA","main":"SingleSignOnErrorPage_main__E2Wuh"};